/**
 * @description Returns the height of all children, including margins
 * @param {Element} element
 * @return {*}  {number}
 */
const getChildrenHeight = (element: Element): number => {
    const childrenHeight = Array.from(element.children).reduce<number>((totalHeight, element) => {
        return totalHeight + getElementHeight(element);
    }, 0);

    return childrenHeight;
};

/**
 * @description Returns the height of an Element, including margins
 * @param {Element} element
 * @return {number}
 */
const getElementHeight = (element: Element): number => {
    let height: number = element.clientHeight;

    const style = window.getComputedStyle(element);

    const marginTop = parseInt(style.marginTop);
    const marginBottom = parseInt(style.marginBottom);

    if (marginTop) height += marginTop;
    if (marginBottom) height += marginBottom;

    return height;
};

export { getChildrenHeight };
